<template>
  <div>
    <PurchaseForm :stamp="$route.params.stamp" />
  </div>
</template>

<script>
import PurchaseForm from "@/components/purchases/PurchaseForm.vue";

export default {
  name: "PurchaseFormView",
  components: { PurchaseForm },
};
</script>
